// Librairies
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';

// Interfaces
import { TEMPLATE_DESCRIPTION_MAX, TEMPLATE_THEMES, TemplateMeta, TemplateTheme } from 'src/app/interfaces/api/chart';

// Components
import { ButtonComponent } from 'ui-library';

// Title, theme and description of a catalog template (dev/admin); closes with them, or nothing when cancelled.
@Component({
  selector: 'app-template-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    TranslateModule,
    ButtonComponent
  ],
  templateUrl: './template-dialog.component.html',
  styleUrl: './template-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class TemplateDialogComponent {
  // Services
  private readonly dialogRef: MatDialogRef<TemplateDialogComponent> = inject(MatDialogRef<TemplateDialogComponent>);
  private readonly data: Partial<TemplateMeta> & { editing?: boolean } = inject(MAT_DIALOG_DATA) ?? {};

  // Variables
  readonly themes: readonly TemplateTheme[] = TEMPLATE_THEMES;
  readonly descriptionMax: number = TEMPLATE_DESCRIPTION_MAX;
  readonly editing: boolean = !!this.data.editing;
  title: string = this.data.title ?? '';
  theme: TemplateTheme = this.data.theme ?? 'general';
  description: string = this.data.description ?? '';

  get valid(): boolean {
    return !!this.title.trim() && this.description.length <= this.descriptionMax;
  }

  themeLabel(theme: TemplateTheme): string {
    return theme === 'general' ? 'catalog.theme_general' : `synthesis.${theme}.title`;
  }

  save(): void {
    if (!this.valid) return;
    const description = this.description.trim();
    this.dialogRef.close({ title: this.title.trim(), theme: this.theme, ...(description ? { description } : {}) } as TemplateMeta);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
